module.exports = __webpack_public_path__ + "static/media/4-5-v-nebi-korunoval.cb3f7496.jpg";